import axios from 'axios';
import { clearSession } from './session';

const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;

const api = axios.create({
    baseURL: apiBaseUrl
});

api.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('access_token');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

api.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response?.status === 401) {
            const path = window.location.pathname;
            if (path.startsWith('/admin') && path !== '/admin/login') {
                clearSession();
                window.location.href = '/admin/login';
            }
        }
        return Promise.reject(error);
    }
);

export default api;